'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_e182d482 = {"container":"Layout_module_container__376cc73c"};
require("../../../assets/cjs/components/Layout/src/Layout~DViGWpTl.css");

exports.default = modules_e182d482;
//# sourceMappingURL=Layout.module.less.js.map
